import { AI_MODEL } from '@vindr/services/constants/ai.constant';
import {
  Button,
  ConfigProvider,
  Popover,
  Select,
  Typography,
  theme,
} from 'antd';
import { useTranslation } from 'react-i18next';
import './AIAnalyze.css';

const { Title } = Typography;
const { Option } = Select;

const Description_Model = {
  [AI_MODEL.CHEST_XRAY]: {
    content: `CHEST_XRAY.content`,
    input: `CHEST_XRAY.input`,
    output: `CHEST_XRAY.output`,
  },
  [AI_MODEL.SPINE_XR]: {
    content: `SPINE_XR.content`,
    input: `SPINE_XR.input`,
    output: `SPINE_XR.output`,
  },
  [AI_MODEL.MAMMOGRAPHY]: {
    content: `MAMMOGRAPHY.content`,
    input: `MAMMOGRAPHY.input`,
    output: `MAMMOGRAPHY.output`,
  },
  [AI_MODEL.LUNG_CT]: {
    content: `LUNG_CT.content`,
    input: `LUNG_CT.input`,
    output: `LUNG_CT.output`,
  },
  [AI_MODEL.LIVER_CT]: {
    content: `LIVER_CT.content`,
    input: `LIVER_CT.input`,
    output: `LIVER_CT.output`,
  },
  [AI_MODEL.BRAIN_CT]: {
    content: `BRAIN_CT.content`,
    input: `BRAIN_CT.input`,
    output: `BRAIN_CT.output`,
  },
  [AI_MODEL.BRAIN_MRI]: {
    content: `BRAIN_MRI.content`,
    input: `BRAIN_MRI.input`,
    output: `BRAIN_MRI.output`,
  },
};

function AIAnalyze({
  AIAnalyzeList,
  selectedModel,
  setSelectedModel,
  onAnalyze,
  canAnalyze = true,
}) {
  const { t } = useTranslation('ViewerTool');
  // const { studyInstanceUIDs = '' } = useParams();
  // const viewports = useSelector(state => state.viewports);
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   if (loading) {
  //     notification.open({
  //       key: 'ai-analyze',
  //       message: (
  //         <>
  //           <LoadingOutlined />
  //           <span style={{ paddingLeft: 20 }}>{t('Analyzing...')}</span>
  //         </>
  //       ),
  //       placement: 'bottomRight',
  //       duration: 0,
  //       className: 'collapse-report',
  //       onClose: () => {
  //         clearInterval(interval);
  //         setLoading(false);
  //       },
  //     });
  //   } else {
  //     // notification.close('ai-analyze');
  //   }
  // }, [loading, t]);

  const handleChangeModel = (item) => {
    setSelectedModel(item);
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontSize: 12,
          borderRadiusSM: 2,
          borderRadiusLG: 2,
          borderRadius: 2,
          colorPrimary: '#39C2D7',
          colorPrimaryHover: '#2799b0',
          colorText: '#fff',
          colorBgBase: '#172126',
          colorBgContainer: 'transparent',
          colorBorder: '#647a87',
          controlItemBgActiveDisabled: '#2C4654',
          controlItemBgActive: '#2C4654',
          controlOutlineWidth: 0,
          colorBgElevated: '#1F313B',
        },
        components: {
          Menu: {
            colorItemBg: 'transparent',
            colorItemBgSelected: '#2c5166',
          },
          Popover: {
            zIndexPopup: 1100,
          },
        },
      }}
    >
      <div className="ai-analyze mb-2 flex w-full">
        <Select
          value={selectedModel}
          placeholder={t('Select CAD Tool')}
          onChange={handleChangeModel}
          className="select-model w-full"
          popupClassName="dropdown-options-dark vindr-dropdown"
        >
          {AIAnalyzeList.map((item) => (
            <Option value={item.key} key={item.key} disabled={item?.disabled}>
              <Popover
                content={() => (
                  <div className="popover-CAD text-sm">
                    <Title level={4} className="mt-0 mb-0">
                      {item.name}
                    </Title>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t(Description_Model[item.key].content),
                      }}
                    />
                    <Title level={5} className="mt-2 mb-0">
                      {t('Input')}
                    </Title>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t(Description_Model[item.key].input),
                      }}
                    />
                    <Title level={5} className="mt-2 mb-0">
                      {t('Output')}
                    </Title>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t(Description_Model[item.key].output),
                      }}
                    />
                  </div>
                )}
                trigger="hover"
                placement="left"
                overlayStyle={{
                  maxWidth: '50vw',
                  width: '50vw',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {item.name}
              </Popover>
            </Option>
          ))}
        </Select>
        {/* {keycloak.hasOneOfPerm([NEW_SCOPES.worklist.cad.analyze]) && ( */}
        {canAnalyze && (
          <Button
            type="primary"
            className="btn-analyze ml-2"
            onClick={onAnalyze}
            // disabled={!keycloak.hasOneOfPerm([NEW_SCOPES.worklist.cad.analyze])}
          >
            {t('Analyze')}
          </Button>
        )}
        {/* )} */}
      </div>
    </ConfigProvider>
  );
}

export default AIAnalyze;

// function isHasAbnormal(data = {}) {
//   try {
//     const abnormalValue = get(data, 'ai_result.result.global.Abnormal');
//     if (abnormalValue && parseFloat(abnormalValue) * 100 >= 50) {
//       return true;
//     }
//   } catch (error) {
//     // Sentry.captureException(error);
//     console.error(error);
//   }

//   return false;
// }
